/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_Tool_1Inputs */

const en_mk_tb_example_tool_1 = /** @type {(inputs: Mk_Tb_Example_Tool_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal AI · active claim`)
};

const id_mk_tb_example_tool_1 = /** @type {(inputs: Mk_Tb_Example_Tool_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI pribadi · klaim aktif`)
};

/**
* | output |
* | --- |
* | "Personal AI · active claim" |
*
* @param {Mk_Tb_Example_Tool_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_tool_1 = /** @type {((inputs?: Mk_Tb_Example_Tool_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_Tool_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_tool_1(inputs)
	return en_mk_tb_example_tool_1(inputs)
});